import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import NewsCompleteAnimation from '@/assets/animation/NewsComplete.json';

import { useAppSelector } from '@/redux/store';
import NewsShareButton from './NewsShareButton';
import { AnimatePresence, motion } from 'framer-motion';
// import { useState } from 'react';
import PushNotAllowedArea from './PushNotAllowedArea';

type OverviewTopSectionProps = {
  lottieRef: React.RefObject<LottieRefCurrentProps>;
};

const OverviewTopsection = ({ lottieRef }: OverviewTopSectionProps) => {
  const lottieProps = {
    lottieRef,
    className: 'w-[60px]',
    animationData: NewsCompleteAnimation,
    loop: false,
    autoplay: false,
  };

  const { NewsBriefingAlertYn } = useAppSelector((state) => state.user);
  const isPushAllowed = NewsBriefingAlertYn === 'Y' || NewsBriefingAlertYn === undefined;

  return (
    <div className="flex w-full flex-col items-center  gap-[20px] ">
      <Lottie {...lottieProps} />
      <TopAlertText />
      <AnimatePresence mode="popLayout">
        {isPushAllowed ? (
          <motion.div
            key="allowed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            layoutId="shareArea"
            className="flex w-full items-center justify-center"
          >
            <PushAllowedArea />
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            key="notAllowed"
            layoutId="shareArea"
            className="flex w-full items-center justify-center"
          >
            <PushNotAllowedArea />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default OverviewTopsection;

const TopAlertText = () => {
  return (
    <div className="flex flex-col items-center  text-gr-800 Title3S18">
      <div className="">오늘의 이커머스 소식을</div>
      <div className="">모두 확인했어요!</div>
    </div>
  );
};

const PushAllowedArea = () => {
  return (
    <div className="flex w-full items-center justify-center gap-[10px]">
      <p className="text-gr-700 Body5M14">도움이 되었다면?</p>
      <NewsShareButton variant="Secondary" />
    </div>
  );
};
